// File: EVOLVE/Projects/cristTools/client/src/components/financial/AccountsManager.js
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAccounts } from '../../features/financial/financialSlice';

const AccountsManager = () => {
  const dispatch = useDispatch();
  const { accounts, loading } = useSelector((state) => state.financial);

  useEffect(() => {
    dispatch(fetchAccounts());
  }, [dispatch]);

  if (loading) {
    return <div>Loading accounts...</div>;
  }

  return (
    <div className="p-4">
      <div className="bg-white p-6 rounded-lg shadow">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Accounts</h3>
          <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
            Add Account
          </button>
        </div>
        <div className="space-y-4">
          {accounts.map((account) => (
            <div key={account._id} className="border p-4 rounded-lg">
              <div className="flex justify-between items-center">
                <div>
                  <h4 className="font-semibold">{account.name}</h4>
                  <p className="text-sm text-gray-500">{account.type}</p>
                </div>
                <div className="text-right">
                  <p className="font-semibold">${account.balance.toLocaleString()}</p>
                  <p className="text-sm text-gray-500">{account.currency}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccountsManager;